import { render } from "./slider.vue?vue&type=template&id=0aea41c6&scoped=true"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import "./slider.vue?vue&type=style&index=0&id=0aea41c6&scoped=true&lang=css"

import exportComponent from "/var/deploy/staging2/web_head/releases/20260929065437/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aea41c6"]])

export default __exports__